/** Locale de la app; debe coincidir con el registrado en register-locales.ts */
export const APP_LOCALE = 'es-PE';
